/* tslint:disable */

/* eslint-disable */

/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists, mapValues } from "../runtime";

/**
 *
 * @export
 * @interface GroupUpdateRequest
 */
export interface GroupUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof GroupUpdateRequest
   */
  name?: string;
  /**
   *
   * @type {Date}
   * @memberof GroupUpdateRequest
   */
  deletedAt?: Date;
}

export function GroupUpdateRequestFromJSON(json: any): GroupUpdateRequest {
  return GroupUpdateRequestFromJSONTyped(json, false);
}

export function GroupUpdateRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GroupUpdateRequest {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    name: !exists(json, "name") ? undefined : json["name"],
    deletedAt: !exists(json, "deleted_at")
      ? undefined
      : new Date(json["deleted_at"]),
  };
}

export function GroupUpdateRequestToJSON(
  value?: GroupUpdateRequest | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    name: value.name,
    deleted_at:
      value.deletedAt === undefined ? undefined : value.deletedAt.toISOString(),
  };
}
